import Rating from "@JohnLewisPartnership/jl-design-system/dist/components/rating/Rating";
import { CardComponentProps } from "@~/types/types";
import { PDPLink } from "../__shared__/PDPLink/PDPLink";
import { SuffixType } from "@JohnLewisPartnership/jl-design-system/dist/components/rating/Rating.types";
import { RatingsCompact } from "./RatingsCompact/RatingsCompact";
import styles from "./Ratings.module.scss";

export const Ratings = ({
  product,
  configProps,
}: Pick<CardComponentProps, "product" | "configProps">) => {
  if (!product.reviewSummary || !product.reviewSummary.numberOfReviews) {
    return null;
  }

  const isCompact = configProps?.size === "compact";
  const shouldHideRatingsOnMobile =
    configProps?.shouldHideRatingsOnMobile === true;
  const suffixType = (configProps?.suffixType || "count") as SuffixType;

  const compactRating = (
    <RatingsCompact averageRating={product.reviewSummary.averageRating} />
  );

  const standardRating = (
    <Rating
      size="large"
      suffixType={suffixType}
      rating={{
        averageRating: product.reviewSummary.averageRating,
        reviews: product.reviewSummary.numberOfReviews,
      }}
    />
  );

  return (
    <PDPLink
      product={product}
      componentName="Ratings"
      tabIndex={-1}
      className={shouldHideRatingsOnMobile ? styles.hideOnMobile : undefined}
    >
      {isCompact ? (
        compactRating
      ) : shouldHideRatingsOnMobile ? (
        <div className={styles.standard}>{standardRating}</div>
      ) : (
        standardRating
      )}
    </PDPLink>
  );
};
